import React, { PureComponent, Fragment } from 'react'
import AnimateHeight from 'react-animate-height'

class Accordion extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: props.defaultOpen,
        }
    }

    toggleOpen = () => {
        const { toggleOpen, onOpen } = this.props
        const stateCopy = { ...this.state }
        stateCopy.isOpen = !stateCopy.isOpen
        if (typeof onOpen === 'function') {
            onOpen(stateCopy.isOpen)
        }
        if (typeof toggleOpen === 'function') {
            toggleOpen(stateCopy.isOpen)
        } else {
            this.setState(stateCopy)
        }
    }

    getIcon = (loading) => {
        const { state } = this
        const { openIcon, closeIcon } = this.props

        let icon = openIcon || 'fal fa-plus'

        if (loading) {
            icon = 'loader'
        } else if (state.isOpen) {
            icon = closeIcon || 'fal fa-minus'
        }

        return icon
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen !== undefined && nextProps.isOpen !== this.state.isOpen) {
            const stateCopy = { ...this.state }
            stateCopy.isOpen = nextProps.isOpen
            this.setState(stateCopy)
        }
    }

    render() {
        const {
            title, children, loading, cssClass, height,
        } = this.props
        const className = cssClass || ''
        return (
            <Fragment>
                <h2 onClick={this.toggleOpen} className={className}>
                    <a>
                        {title}
                        <i className={this.getIcon(loading)} />
                    </a>
                </h2>
                <AnimateHeight
                    duration={250}
                    height={this.state.isOpen ? height || 'auto' : 0} // see props documentation below
                >
                    {children}
                </AnimateHeight>
            </Fragment>
        )
    }
}

export default Accordion
